import { ReactElement } from 'react';
import styled from 'styled-components';
import { EIconSize } from 'utils/constants/app/ui';
import { isMobile } from 'utils/is-mobile';
import { GlobalIcon } from 'components/GlobalIcon';
import './index.less';

const Container = styled.span`
  display: flex;
  align-items: center;
  padding: 10px;
  margin-top: 4px;
  color: var(--v3-text-color);
  background: var(--v3-black-0);
  ${!isMobile() &&
  `
    border-radius: 4px;
  `}
`;

type Props = {
  textInfo: string;
  style?: any;
};

export const TextInfo = ({
  textInfo,
  style = {}
}: Props): ReactElement | null => {
  return textInfo ? (
    <Container style={{ ...style }}>
      <GlobalIcon
        lib="generic"
        name="info"
        theme="default"
        size={EIconSize._16}
        className="gameDetails__info-icon"
      />
      {textInfo}
    </Container>
  ) : null;
};
